function addCollapseButton(accordionElement) {
    const button = accordionElement.querySelector('.accordion-button');
    const container = accordionElement.querySelector('.accordion-container');

    button.addEventListener('click', function () {
        accordionElement.classList.toggle('active');

        //Fecha accordions do mesmo grupo
        const accordionGroup = accordionElement.getAttribute('accordion-group');
        document.querySelectorAll('.accordion[accordion-group="' + accordionGroup + '"]').forEach(function (elm) {
            if (elm !== accordionElement) {
                elm.classList.remove('active');
                elm.querySelector('.accordion-container').style.maxHeight = '0';
            }
        });

        //Expande container
        const isCollapsed = accordionElement.classList.contains('active');
        if (isCollapsed) {
            container.style.maxHeight = container.scrollHeight + 'px';
        } else {
            container.style.maxHeight = '0';
        }
    });
}

function addCollapseButtonsToCollapsableElements() {
    const collapsableElements = document.querySelectorAll('.accordion');

    collapsableElements.forEach((element) => {
        addCollapseButton(element);
    });
}

document.addEventListener('DOMContentLoaded', addCollapseButtonsToCollapsableElements);
